/** 预渲染环境标记：Puppeteer / 注入变量 */
export function isPrerenderEnv() {
  if (typeof window === 'undefined') return false
  if (window.__PRERENDER_INJECTED) return true
  const ua = navigator.userAgent || ''
  return /HeadlessChrome|Prerender/i.test(ua)
}

export function notifyPrerenderReady() {
  if (typeof document === 'undefined') return
  requestAnimationFrame(() => {
    setTimeout(() => {
      document.dispatchEvent(new Event('prerender-ready'))
    }, 800)
  })
}
